/**
 * K5 switch (docs/DESIGN_K5_credential-encryption.md §3.3).
 *
 * When true, saved logins (passwords, loyalty accounts, portal logins on
 * checklist items) are encrypted on the device before they reach the API,
 * under a key derived from the account's master key. Saving then needs a
 * Recovery Code, as documents do.
 *
 * Reading has no switch: a value that carries the `fkc1:` prefix is always
 * decrypted, so this flag can be turned on once the read side has shipped
 * everywhere (phase (a) ships reads with this false; phase (b) flips it).
 */
export const CREDENTIAL_WRITES_ENCRYPTED = true;
